import React, { useEffect, useState, useRef } from "react";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { baseURL, fetch, post, postForm } from "../../Util/axios_helper";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import { useDispatch, useSelector } from "react-redux";
import {
  getCulturalList,
  getFunctionTypes,
  onCulturalEdit,
} from "../Email/configuration_slice";
import { KendoLoader } from "../../Kendo/kendo_loader";
import {
  Button,
  ErrorMsg,
  GetFormData,
  Loader,
  ValidateForm,
  checkAccess,
  confirmDelete,
} from "../../Util/common";

export const BallroomCulture = ({ selTab }) => {
  const dispatch = useDispatch();
  const { functionTypes, culturalList, culturalListLoaded, selFunctionTypes } =
    useSelector((state) => state.configuration);
  const [error, setError] = useState({});
  const [editVisible, setEditVisible] = useState(false);
  const [cultureName, setCultureName] = useState("");
  const modalRef = useRef(null);
  const [Loading, setLoading] = useState(false);
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setCultureName("");
    setError({});
    dispatch(onCulturalEdit(null));
    setEditVisible(false);
  };

  useEffect(() => {
    if (selTab == 3) {
      dispatch(getFunctionTypes(0));
      dispatch(getCulturalList());
      if (modalRef.current) {
        $(modalRef.current).on("hidden.bs.modal", () => {
          clearForm();
        });
      }

      return () => {
        if (modalRef.current) {
          $(modalRef.current).off("hidden.bs.modal");
        }
      };
    }
  }, [selTab]);

  useEffect(() => {}, [functionTypes, culturalListLoaded]);

  const onSubmit = async (e) => {
    e.preventDefault();
    let isDuplicate = false;
    const matchingItem = culturalList.find(
      (item) => item.CultureId == editVisible.cultureId
    );
    const CultureNameValue = matchingItem ? matchingItem.CultureName : null;
    const dup = CultureNameValue != cultureName;

    if (dup) {
      isDuplicate = culturalList.some(
        (item) =>
          item.CultureName.trim().toLowerCase() ==
          cultureName.trim().toLowerCase()
      );
    }
    var err = ValidateForm(e);
    if (err) {
      setError((prev) => ({
        ...prev,
        ...err,
      }));
    } else if (!isDuplicate) {
      setLoading(true);
      var data = GetFormData(e);
      if (editVisible && editVisible.visible) {
        data.CultureId = editVisible.cultureId;
      }
      try {
        if (editVisible && editVisible.visible) {
          await post(
            "Configuration/SaveCulture",
            data,
            true,
            false,
            false,
            true
          );
        } else {
          await post("Configuration/SaveCulture", data);
        }
        $("#ballroom-cul-cancel").click();
        clearForm();
        dispatch(getCulturalList());
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleEditClick = async (e) => {
    const data = await fetch(
      `Configuration/GetCultureById?CultureId=${e.CultureId}`
    );
    dispatch(onCulturalEdit(data));
    setCultureName(data.CultureName);
    setEditVisible({
      visible: true,
      cultureId: e.CultureId,
    });
    const modal = new bootstrap.Modal(document.getElementById("add_culture"));
    modal.show();
  };

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      fetch(
        `Configuration/DeleteCulture?CultureId=${e.CultureId}`,
        true,
        false,
        true
      ).then(() => {
        dispatch(getCulturalList(0));
      });
    };
    confirmDelete(onDelete);
  };
  return (
    <>
      <div className="col-auto ms-auto">
        <div className="row">
          <div className="col-sm-6"></div>
          {checkAccess("APPCONFIGCREATE") && (
            <div className="col-auto float-end ms-auto">
              <div className="d-flex justify-content-end mb-2">
                <Button
                  name={"Add Culture"}
                  dataBsToggle={"modal"}
                  dataBsTarget={"#add_culture"}
                  dataBsDismiss={"modal"}
                />
              </div>
            </div>
          )}
        </div>

        <div>
          {!culturalListLoaded ? (
            <div className="row">
              {" "}
              <div className="col-12">
                <KendoLoader />
              </div>
            </div>
          ) : (
            <KendoGrid
              name={"culture-config"}
              data={culturalList}
              schema={{}}
              columns={[
                {
                  field: "CultureId",
                  filterable: false,
                  hidden: true,
                },
                {
                  field: "CultureName",
                  title: "Culture Name",
                },

                {
                  template: "#=FunctionTypeNames#",
                  field: "FunctionTypeNames",
                  title: "Function Type",
                },
              ]}
              showOptions={
                checkAccess("APPCONFIGEDIT") || checkAccess("APPCONFIGDELETE")
              }
              showEdit={checkAccess("APPCONFIGEDIT")}
              showDelete={checkAccess("APPCONFIGDELETE")}
              onEditClick={(e) => handleEditClick(e)}
              onDeleteClick={(e) => {
                handleDeleteClick(e);
              }}
              disableExportExcel={true}
            />
          )}
        </div>
      </div>
      {/* <!-- Add Culture Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_culture"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editVisible ? "Edit Culture" : "Add Culture"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-culture-config" onSubmit={onSubmit}>
                <div className="input-block mb-3">
                  <label className="form-label">
                    Culture <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    className="form-control field"
                    name="CultureName"
                    value={cultureName}
                    placeholder="Culture"
                    data-required="true"
                    onChange={(e) => {
                      setCultureName(e.target.value);
                      onValidation("CultureName", e.target.value);
                      const matchingItem = culturalList.find(
                        (item) => item.CultureId == editVisible.cultureId
                      );
                      const CultureNameValue = matchingItem
                        ? matchingItem.CultureName
                        : null;
                      const dup = CultureNameValue != e.target.value;
                      if (dup) {
                        const isDuplicate = culturalList.some(
                          (item) =>
                            item.CultureName.trim().toLowerCase() ==
                            e.target.value.trim().toLowerCase()
                        );

                        setError((prevError) => ({
                          ...prevError,
                          CNDuplicate: isDuplicate,
                        }));
                      }
                    }}
                  />
                  {error.CultureName && <ErrorMsg text="Culture is required" />}
                  {error.CNDuplicate && (
                    <ErrorMsg text="Culture is already exist" />
                  )}
                </div>
                <div className="input-block mb-3">
                  <label className="form-label">
                    Function Type <span className="text-danger">*</span>
                  </label>
                  <KendoMultiSelect
                    name="FunctionTypeIds"
                    data={functionTypes}
                    placeholder={"Select function type..."}
                    dataTextField={"FunctionType"}
                    dataValueField={"FunctionTypeId"}
                    value={selFunctionTypes}
                    required={true}
                    onValidate={onValidation}
                  />
                  {error.FunctionTypeIds && (
                    <ErrorMsg text="Function Type is required" />
                  )}
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="ballroom-cul-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add Culture Modal --> */}
    </>
  );
};
